import React from 'react';
import './Popup.css'; // Assuming you have some CSS for styling
import CheckmarkIcon from '../../assets/Tick Circle.svg';
import { Button, Box, Typography } from '@mui/material';

interface PopupProps {
  title?: React.ReactNode;
  message?: React.ReactNode;
  buttonText?: string;
  onButtonClick: () => void;
  secondaryButtonText?: string;
  onSecondaryButtonClick?: () => void;
  icon?: any;
}

const Popup: React.FC<PopupProps> = ({
  icon,
  title,
  message,
  buttonText,
  secondaryButtonText,
  onButtonClick,
  onSecondaryButtonClick,
}) => {
  return (
    <Box
      className="popup"
      sx={{
        px: { xs: '40px', sm: '40px' },
        py: 4,
        width: { xs: '90vw', sm: '350px', md: '350px', xl: '350px' },
      }}
    >
      <Box
        sx={{
          gap: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          alt="tickicon"
          src={icon ? icon : CheckmarkIcon}
          className="checkmark-icon"
        />
        {title && (
          <Typography
            variant="h6"
            className="popup-title"
            sx={{ lineHeight: '1.4' }}
          >
            {title}
          </Typography>
        )}
        {message && (
          <Typography variant="body2" className="popup-message">
            {message}
          </Typography>
        )}
        <Box sx={{ mt: 2 }}>
          {onSecondaryButtonClick && (
            <Button
              variant="contained"
              className="popup-button"
              onClick={onSecondaryButtonClick}
              sx={{
                fontFamily: 'Opensans',
                backgroundColor: 'black',
                '&:hover': { backgroundColor: 'black' },
                border: '1px solid rgba(251, 80, 18, 1)',
                color: 'rgba(251, 80, 18, 1)',
                borderRadius: '38px',
                textTransform: 'none',
                padding: '11px 28px',
                marginRight: '16px',
              }}
            >
              {secondaryButtonText || 'Continue'}
            </Button>
          )}
          <Button
            variant="contained"
            className="popup-button"
            onClick={onButtonClick}
            sx={{
              fontFamily: 'Opensans',
              backgroundColor: 'rgba(251, 80, 18, 1)',
              '&:hover': { backgroundColor: 'rgba(251, 80, 18, 1)' },
              borderRadius: '38px',
              textTransform: 'none',
              padding: '11px 28px',
            }}
          >
            {buttonText || 'Continue'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Popup;
